const TasksBrowseRouteNavigationOptions = {
  title: 'Tasks',
  headerTitle: 'Tasks',
  headerBackVisible: false,
};

export default TasksBrowseRouteNavigationOptions;
